// extracted by mini-css-extract-plugin
export default {"modalHeader":"modalHeader_modalHeader__HKoqT","closeButton":"modalHeader_closeButton__5F+do"};